class CartDiscount extends HTMLInputElement {
  constructor() {
    super()

    this.submitForm = this.submitForm.bind(this)
    this._form = this.closest('[data-discount-field-form]')
  }
  connectedCallback() {
    if (!this._form) return
    this._form.addEventListener('submit', this.submitForm)
  }

  disconnectedCallback() {
    if (!this._form) return
    this._form.removeEventListener('submit', this.submitForm)
  }

  async submitForm(event) {
    event.preventDefault()
    const discountCodeValue = this.value.trim()
    if (!discountCodeValue) return
    const sectionId = this.dataset.sectionId
    if (!sectionId) return

    try {
      const existingDiscounts = this.existingDiscounts()
      if (existingDiscounts.includes(discountCodeValue)) return

      const config = {
        discount: [...existingDiscounts, discountCodeValue].join(','),
        sections: [sectionId],
      }

      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(config),
        }
      )

      if (!response.ok) {
        throw new Error(`Discount request failed: ${response.status}`)
      }

      const data = await response.json()

      const invalidDiscount = data.discount_codes.find(
        (/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false
        }
      )

      if (invalidDiscount) {
        this.value = ''
        this.handleDiscountError('discount_code')
        return
      }

      const newHtml = data.sections[sectionId]
      if (!newHtml) return null
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html')
      const section = parsedHtml.getElementById(
        `shopify-section-${sectionId}`
      )

      const discountCodes =
        section?.querySelectorAll('[data-discount-code]') || []
      if (section) {
        const codes = Array.from(discountCodes)
          .map((element) =>
            element instanceof HTMLSpanElement || element instanceof HTMLLIElement
              ? element.dataset.discountCode
              : null
          )
          .filter(Boolean)

        if (
          codes.length === existingDiscounts.length &&
          codes.every((/** @type {string} */ code) =>
            existingDiscounts.includes(code)
          ) &&
          data.discount_codes.find(
            (
              /** @type {{ code: string; applicable: boolean; }} */ discount
            ) => {
              return (
                discount.code === discountCodeValue &&
                discount.applicable === true
              )
            }
          )
        ) {
          this.handleDiscountError('shipping')
          this.value = ''
          return
        }
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: parsedHtml,
          },
        })
      )

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: parsedHtml,
            openMiniCart:
              window.themeVariables.settings.cartType === 'drawer' &&
              this.closest('.drawer') === null,
          },
        })
      )

      return data
    } catch (error) {
      console.error('Discount update error:', error)
      return null
    }
  }

  handleDiscountError(type) {
    const discountErrorWrapper = document.querySelector(
      '[data-discount-error-wrapper]'
    )
    const discountErrorMessage = document.querySelector(
      '[data-discount-error="error"]'
    )
    const discountShippingMessage = document.querySelector(
      '[data-discount-error="shipping"]'
    )

    const target =
      type === 'discount_code' ? discountErrorMessage : discountShippingMessage
    if (!discountErrorWrapper || !target) return
    discountErrorWrapper.removeAttribute('hidden')
    target.removeAttribute('hidden')
  }

  existingDiscounts() {
    const discountCodes = new Set()
    const discountBadges = document.querySelectorAll('[data-discount-code]')

    for (const badge of discountBadges) {
      if (
        (badge instanceof HTMLLIElement || badge instanceof HTMLSpanElement) &&
        typeof badge.dataset.discountCode === 'string'
      ) {
        discountCodes.add(badge.dataset.discountCode)
      }
    }

    return Array.from(discountCodes)
  }
}

if (!customElements.get('cart-discount')) {
  customElements.define('cart-discount', CartDiscount, { extends: 'input' })
}
